import * as React from 'react';
const classNames = require('classnames');

import Label from './Label';

export interface Option {
	value: string;
	text: string;
}

interface Props {
	labelText?: string;
	value?: string | number;
	onBlur?: (value: {}) => void;
	onChange?: (value: {}) => void;
	name: string;
	id?: string;
	defaultOption?: string;
	options: Array<Option>;
	required?: boolean;
	className?: string;
	controlClassName?: string;
	disabled?: boolean;
}
const DropdownInput: React.StatelessComponent<Props> = props => {
	return (
		<div className={classNames('form-group', props.className)}>
			{props.labelText ? (
				<Label htmlFor={props.name} required={props.required}>
					{props.labelText}
				</Label>
			) : null}
			<div className="input-group">
				<select
					className={classNames('form-control', props.controlClassName)}
					id={props.id || props.name}
					name={props.name}
					value={props.value}
					defaultValue={''}
					onBlur={props.onBlur}
					onChange={props.onChange}
					required={true}
					disabled={props.disabled}
				>
					{props.defaultOption && (
						<option value="" disabled={true}>
							{props.defaultOption}
						</option>
					)}
					{props.options.map(option => (
						<option key={option.value} value={option.value}>
							{option.text}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

export default DropdownInput;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/DropdownInput.tsx